import { getShoppingData } from 'actions/shoppingData'
import { rest } from 'services'
import { googleAnalyticCheckout } from 'actions/googleAnalytic'
import { setUpdatingBlock } from 'components/common/UpdatingBlock/actions'
import { SHOPPING_QUOTE_TOTAL_QUANTITY } from 'components/common/UpdatingBlock/constants'

export const updateProductQuantity = (requestData) => (dispatch) =>
  dispatch(getShoppingData(rest.api.updateProduct, requestData))
    .then(() => {
      dispatch(setUpdatingBlock({ name: SHOPPING_QUOTE_TOTAL_QUANTITY, value: false }))
      return dispatch(googleAnalyticCheckout())
    }).catch(() => {
      dispatch(setUpdatingBlock({ name: SHOPPING_QUOTE_TOTAL_QUANTITY, value: false }))
    })

